export let AccordionRootDataAttributes = /*#__PURE__*/function (AccordionRootDataAttributes) {
  /**
   * Present when the accordion is disabled.
   */
  AccordionRootDataAttributes["disabled"] = "data-disabled";
  /**
   * Indicates the orientation of the accordion.
   */
  AccordionRootDataAttributes["orientation"] = "data-orientation";
  return AccordionRootDataAttributes;
}({});